export const Loading = require("./Loading").default;
export const Markdown = require("./Markdown").default;
export const Text = require("./Text").default;
export const Wave = require("./Wave").default;
export const Avatar = require("./Avatar").default;
export const Upload = require("./Upload").default;
export const ImgContainer = require("./ImgContainer").default;
export const VideoCard = require("./VideoCard").default;
export const Card = require("./Card").default;
export const Logo = require("./Logo").default;
export const Comment = require("./Comment").default;
export const CommentInput = require("./CommentInput").default;
export const Feedback = require("./Feedback").default;
export const FeedbackDeal = require("./FeedbackDeal").default;
export const FileList = require("./FileList").default;
export const Book = require("./Book").default;
export const BlurImage = require("./BlurImage").default;
export const Nav = require("./Nav").default;
export const TooltipQR = require("./TooltipQR").default;
export const Scrollbar = require("./Scrollbar").default;
export const ShopPreview = require("./ShopPreview").default;
export const ActiveNumber = require("./ActiveNumber").default;